var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center"},[_c('a',{staticClass:"bg-black py-4 px-6 uppercase",attrs:{"href":"#"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Return to shop")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }